import { jsx as l } from "react/jsx-runtime";
import { useRef as g, useCallback as a, useMemo as v } from "react";
import { useScrollNavigation as w, ScrollNavigation as u } from "../../hooks/scrollNavigation/index.js";
import { CarouselContext as C } from "../../context.js";
import { Container as N } from "./styles.js";
function A({ className: m, children: f, onMove: o, ...p }) {
  const s = g(null), { arrowsNavigation: t, scroll: r, updateNavigators: n } = w(s), e = a(() => {
    r(u.BACK, o);
  }, [o, r]), i = a(() => {
    r(u.FORWARD, o);
  }, [o, r]), c = a((d) => {
    s.current = d.current;
  }, []), R = v(
    () => ({
      scrollBack: e,
      scrollForward: i,
      setListRef: c,
      updateNavigators: n,
      showNextButton: t.forward,
      showPrevButton: t.back
    }),
    [e, i, c, n, t]
  );
  return /* @__PURE__ */ l(C.Provider, { value: R, children: /* @__PURE__ */ l(N, { className: m, ...p, children: f }) });
}
export {
  A as Root
};
